import { Link } from "react-router-dom";
import { useSeo } from "@/hooks/useSeo";

export default function NotFound() {
  useSeo("Not found");
  return (
    <div className="container-lux py-24 lg:py-32 text-center" data-testid="not-found-page">
      <p className="eyebrow">404</p>
      <h1 className="font-display text-6xl sm:text-7xl font-medium mt-3">The piece has moved</h1>
      <p className="text-foreground/70 mt-5 max-w-md mx-auto">The page you were looking for isn't here. Perhaps you'd like to continue exploring from one of the entries below.</p>
      <div className="flex flex-wrap gap-3 justify-center mt-10">
        <Link to="/new-arrivals" className="btn-ink" data-testid="404-new-link">New arrivals</Link>
        <Link to="/designers" className="btn-ghost-lux" data-testid="404-designers-link">Designers A–Z</Link>
        <Link to="/women" className="btn-ghost-lux" data-testid="404-women-link">Women</Link>
        <Link to="/men" className="btn-ghost-lux" data-testid="404-men-link">Men</Link>
      </div>
    </div>
  );
}
